import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatGridListModule } from '@angular/material/grid-list';
import { HttpClientModule } from "@angular/common/http";

import { MapViewComponent } from './components/map-view/map-view.component';
import { PanoramicViewComponent } from './components/panoramic-view/panoramic-view.component';

import { MapService } from './services/map.service';
import { MaterialModule } from '../material/material.module';
import { WidgetsModule } from "../widgets/widgets.module";

@NgModule({
    declarations: [MapViewComponent, PanoramicViewComponent],
    imports: [
        CommonModule,
        MatGridListModule,
        MaterialModule,
        HttpClientModule,
        WidgetsModule
    ],
    providers: [
        MapService
    ],
    exports: [
        MapViewComponent,
        PanoramicViewComponent,

    ]
})
export class ViewModule { }
